import axiosClient from "@/shared/lib/axios/axios";
import { ApiResponse } from "@/shared/types/api";
import { API_ROUTES } from "../config";
import {
  ClassificationExportConfig,
  ClassificationExportConfigCreateInput,
  ClassificationExportConfigUpdateInput,
} from "../../types/config";
import { MOCK_CONFIGS } from "../../mocks/configs-mock-data";

const USE_MOCK = false;

export interface GetConfigsParams {
  organization?: number;
  location?: number;
  machine?: number;
}

export const getExportConfigs = async (params?: GetConfigsParams): Promise<ClassificationExportConfig[]> => {
  try {
    const res = await axiosClient.get<ApiResponse<ClassificationExportConfig[]>>(
      API_ROUTES.CONFIGS_CLASSIFICATION,
      { params }
    );
    const data = res?.data?.data ?? [];
    if (data.length > 0) return data;
    if (USE_MOCK) return MOCK_CONFIGS;
    return data;
  } catch {
    if (USE_MOCK) return MOCK_CONFIGS;
    throw arguments[0];
  }
};

export const getExportConfigById = async (id: number) => {
  try {
    const res = await axiosClient.get<ApiResponse<ClassificationExportConfig>>(
      `${API_ROUTES.CONFIGS_CLASSIFICATION}${id}/`
    );
    return res?.data?.data;
  } catch {
    if (USE_MOCK) return MOCK_CONFIGS.find((c) => c.id === id) ?? MOCK_CONFIGS[0];
    throw arguments[0];
  }
};

export const createExportConfig = async (input: ClassificationExportConfigCreateInput) => {
  return axiosClient
    .post<ApiResponse<ClassificationExportConfig>>(API_ROUTES.CONFIGS_CLASSIFICATION, input)
    .then((res) => res.data.data);
};

export const updateExportConfig = async (id: number, input: ClassificationExportConfigUpdateInput) => {
  return axiosClient
    .patch<ApiResponse<ClassificationExportConfig>>(`${API_ROUTES.CONFIGS_CLASSIFICATION}${id}/`, input)
    .then((res) => res.data.data);
};

export const deleteExportConfig = async (id: number) => {
  return axiosClient
    .delete(`${API_ROUTES.CONFIGS_CLASSIFICATION}${id}/`)
    .then((res) => res.data);
};
